import { Injectable } from '@angular/core';
import { MembershipSelectStepStates, User } from 'src/app/interfaces/user';

export interface RegistrationProgressData {
  readonly isFullNameRegistrationCompleted: boolean;
  readonly isPetChipNumberRegistrationCompleted: boolean;
  readonly isMembershipSelectionCompleted: boolean;
  readonly isWelcomePackSelectCompleted: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RegistrationProgressService {
  constructor() {}

  public getRegistrationProgressData(user: User): RegistrationProgressData {
    const isFullNameRegistrationCompleted =
      this.getFullNameRegistrationState(user);
    const isPetChipNumberRegistrationCompleted =
      this.getPetChipNumberRegistrationState(user);
    const isMembershipSelectionCompleted =
      this.getMembershipSelectionState(user);
    const isWelcomePackSelectCompleted =
      this.getWelcomeGiftCompletedState(user);
    return {
      isFullNameRegistrationCompleted: isFullNameRegistrationCompleted,
      isPetChipNumberRegistrationCompleted:
        isPetChipNumberRegistrationCompleted,
      isMembershipSelectionCompleted: isMembershipSelectionCompleted,
      isWelcomePackSelectCompleted: isWelcomePackSelectCompleted,
    };
  }

  private getFullNameRegistrationState(user: User): boolean {
    return !!user.name?.firstName;
  }

  private getPetChipNumberRegistrationState(user: User): boolean {
    if (user.pets.length === 0) {
      return user.hasOpenTokRequests;
    }

    // The user has pets and all of the pets details are filled --> the step is complete
    if (
      user.pets.length > 0 &&
      user.pets.filter(
        (p) => p.name === null || p.name === '[to_be_completed_by_keeper]'
      ).length === 0
    ) {
      return true;
    }

    // If there are incomplete pets, but the membership selection and welcome gift steps are complete,
    // then the registration is complete, but the user added a new pet later
    const isMemberShipSelectionComplete =
      this.getMembershipSelectionState(user);
    const isWelcomeGiftStepComplete = this.getWelcomeGiftCompletedState(user);
    if (isMemberShipSelectionComplete && isWelcomeGiftStepComplete) return true;

    return false;
  }

  private getMembershipSelectionState(user: User): boolean {
    return !(
      user.membershipSelectStepCompleted &&
      user.membershipSelectStepCompleted ===
        MembershipSelectStepStates.NotUpdated
    );
  }

  private getWelcomeGiftCompletedState(user: User): boolean {
    return !(
      user.welcomeGiftStepCompleted && user.welcomeGiftStepCompleted === 1
    );
  }
}
